import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from '../../service/admin-service.service';

@Component({
  selector: 'app-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.scss'],
})

export class MetricsComponent implements OnInit {
  public id = '';
  public stats: any = [
    {
      name: 'Reseñas',
      id: 'reviewCount',
      value: 0
    },
    {
      name: 'Visitas a productos',
      id: 'viewProduct',
      value: 0
    },
    {
      name: 'Visitas a las tiendas',
      id: 'viewStore',
      value: 0
    },
    {
      name: 'Visitas a la pagina',
      id: 'viewWeb',
      value: 0
    }
  ]

  constructor(
    private adminSv: AdminServiceService
  ) { }

  async ngOnInit() {
    const data: any = await this.adminSv.getStats('metric');
    console.log(data);
    
    for (const value of Object.entries(data)) {
      const stat = this.stats.find(x => x.id === value[0]);
      if(stat){
        stat.value = value[1]
      }
    }
  }

 
  
}
